module.exports = __webpack_public_path__ + "assets/8b79c8bd94120d51dbc00f736687d849.png";